import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from '../../actions/schoolEntryActions';
import { SchoolPrices } from '../../helpers/propTypes';
import PricePaneView from './PricePaneView';

class View extends PureComponent {
  componentDidMount() {
    this.props.getPrices();
  }

  render() {
    const {
      prices, isFreeTrial, paymentStartDate, showEntryFee,
    } = this.props;
    return (
      <PricePaneView
        prices={prices}
        isFreeTrial={isFreeTrial}
        paymentStartDate={paymentStartDate}
        showEntryFee={showEntryFee}
      />
    );
  }
}

View.defaultProps = {
  showEntryFee: true,
};

View.propTypes = {
  prices: SchoolPrices.isRequired,
  isFreeTrial: PropTypes.bool.isRequired,
  paymentStartDate: PropTypes.instanceOf(Date).isRequired,
  getPrices: PropTypes.func.isRequired,
  showEntryFee: PropTypes.bool,
};

export default connect((state) => ({
  prices: state.schoolEntry.prices,
  isFreeTrial: state.schoolEntry.isFreeTrial,
}), (dispatch) => ({
  getPrices: () => dispatch({
    type: Actions.SAGA_GET_PRICES,
  }),
}))(View);
